import React from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

const LanguageSwitcher = ({ className }) => {

    const languages = [
        {
            code: 'en',
            name: 'English'
        },
        {
            code: 'ms',
            name: 'Malay'
        }
    ]

    const { i18n } = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    const toogleLanguage = () => {
        const currentLanguage = i18n.language;
        const newLanguage = currentLanguage === 'en' ? 'ms' : 'en';
        changeLanguage(newLanguage);
    }

    const currentLanguage = i18n.language;

    return (
        <button className={twMerge('font-normal', className)} onClick={toogleLanguage}>
            <span className={twMerge('font-normal opacity-50', currentLanguage === 'ms' && 'font-bold opacity-100')}>
                BM
            </span>
            /
            <span className={twMerge('font-normal opacity-50', currentLanguage === 'en' && 'font-bold opacity-100')}>
                EN
            </span>
        </button>
    );
};

export default LanguageSwitcher; 